/**
 * Send CSRF automatically on each ajax callback if it is needed
 */
$(document).ajaxSend(function( event, request, settings ) {
    if (['post', 'delete', 'patch', 'put'].includes(settings.type.toLowerCase())) {
        request.setRequestHeader('X-CSRF-TOKEN', $('[name="csrf-token"]').attr('content'));
    }
});

/**
 * Logout automatically when an ajax callback respond with status of 401
 */
$(document).ajaxError(function( event, request, settings ) {
    if (request.status === 401) {
        window.location.href = '/login';
    }
});
